<template>
  <add-edit-dialog>
    <crm-panel title="编辑客户">
      <div class="page-buttons">
        <crm-button :text="'保存'" @click="customFormSubmit('customForm', customForm)">
        </crm-button>
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleGoBack()">
        </crm-button>
      </div>
      <el-form
        label-width="180px"
        ref="customForm"
        :model="customForm"
        :rules="customFormRules"
        class="add-edit-form"
      >
        <el-form-item
          label="客户类型："
          prop="commonCustomer.categoryUid"
          :rules="customFormRules.commonCustomer.categoryUid"
        >
          <el-col :span="5">
            <el-select
              clearable
              v-model="customForm.commonCustomer.categoryUid"
              placeholder="请选择"
              @change="handleCustomerTypeChange"
            >
              <el-option
                v-for="item in customType"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="客户等级：" prop="commonCustomer.customerLevel">
          <el-col :span="11">
            <el-select
              clearable
              v-model="customForm.commonCustomer.customerLevel"
              placeholder="客户等级"
            >
              <el-option
                v-for="item in customLevelList"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <div v-if="customerModule === 1">
          <el-form-item
            label="客户名称："
            class="is-required"
            prop="commonCustomer.name"
            :rules="[]"
          >
            <el-row>
              <el-col :span="11">
                <el-form-item
                  prop="commonCustomer.name"
                  :rules="customFormRules.commonCustomer.name"
                >
                  <el-input
                    v-model="customForm.commonCustomer.name"
                    placeholder="公司名称"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="统一社会信用代码："
            @blur="creditCodeValidate"
            prop="creditCode"
          >
            <el-col :span="11">
              <el-input v-model="customForm.creditCode"> </el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            label="注册资金："
            prop="commonCustomer.capital"
            :rules="customFormRules.commonCustomer.capital"
          >
            <el-col :span="11">
              <el-input v-model="customForm.commonCustomer.capital"> </el-input>
            </el-col>
            <el-col :span="1" style="marginleft: 10px">
              <span>万元</span>
            </el-col>
          </el-form-item>
          <el-form-item label="规模：" prop="commonCustomer.scale">
            <el-col :span="11">
              <el-select clearable v-model="customForm.commonCustomer.scale">
                <el-option
                  v-for="item in scaleOption"
                  :label="item.label"
                  :value="item.label"
                  :key="item.key"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </div>
        <div v-if="customerModule === 2">
          <el-row>
            <el-col :span="10">
              <el-form-item
                label="客户名称："
                prop="commonCustomer.name"
                :rules="customFormRules.commonCustomer.name"
              >
                <el-input v-model="customForm.commonCustomer.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="跟进状态："
                prop="followUpState"
                :rules="customFormRules.followUpState"
              >
                <el-select clearable v-model="customForm.followUpState">
                  <el-option
                    v-for="item in customerFollowUp ? customerFollowUp : ''"
                    :label="item.name"
                    :value="item.uid"
                    :key="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item
                label="医院等级："
                prop="hospitalLevel"
                :rules="customFormRules.hospitalLevel"
              >
                <el-select clearable v-model="customForm.hospitalLevel">
                  <el-option
                    v-for="item in hospitalLevel ? hospitalLevel : ''"
                    :label="item.name"
                    :value="item.uid"
                    :key="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="病床数：" prop="sickbedNumber">
                <el-input v-model="customForm.sickbedNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="覆盖人口(万)：" prop="coverPopulation">
                <el-input v-model="customForm.coverPopulation"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="当地医院排名：" prop="hospitalRhanking">
                <el-input v-model="customForm.hospitalRhanking"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="年收入(万)：" prop="annualIncome">
                <el-input v-model="customForm.annualIncome"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="职工人数：" prop="employeeNumber">
                <el-input v-model="customForm.employeeNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="年门诊人次(万)：" prop="outpatientVisits">
                <el-input v-model="customForm.outpatientVisits"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="合作科室：" prop="allCustomerDetail">
                <el-select clearable v-model="customForm.allCustomerDetail" multiple>
                  <el-option
                    :key="item.uid"
                    v-for="item in coprationDepartment ? coprationDepartment : ''"
                    :label="item.name"
                    :value="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="年住院人次(万)：" prop="hospitalizationVisits">
                <el-input v-model="customForm.hospitalizationVisits"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="负债率：" prop="liabilities">
                <el-input v-model="customForm.liabilities"></el-input>
                <span style="position: absolute; top: 0px; right: 10px">%</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="医疗设备：" prop="medicalEquipment">
              <el-radio-group
                v-model="customForm.medicalEquipment"
                @change="changeMedicalEquipment"
              >
                <el-radio :label="1">有</el-radio>
                <el-radio :label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <div v-if="customForm.medicalEquipment === 1">
            <div>
              <el-form-item label="设备名称：" prop="deviceName">
                <el-col :span="11">
                  <el-input type="textarea" :rows="4" v-model="customForm.deviceName">
                  </el-input>
                </el-col>
              </el-form-item>
            </div>
            <el-row>
              <el-col :span="10">
                <el-form-item label="设备总金额(万元)：" prop="deviceAmount">
                  <el-input v-model="customForm.deviceAmount"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-form-item label="耗材：" prop="consumables">
              <el-radio-group
                v-model="customForm.consumables"
                @change="changeConsumables"
              >
                <el-radio :label="1">有</el-radio>
                <el-radio :label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row v-if="customForm.consumables === 1">
            <el-col :span="10">
              <el-form-item
                label="预估耗材流水(万元/年)："
                prop="consumablesRunningWater"
              >
                <el-input v-model="customForm.consumablesRunningWater"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <el-form-item label="备注：" prop="customerRemarks">
              <el-col :span="11">
                <el-input type="textarea" :rows="4" v-model="customForm.customerRemarks">
                </el-input>
              </el-col>
            </el-form-item>
          </div>
        </div>
        <el-form-item
          label="地区："
          prop="commonCustomer.province"
          :rules="customFormRules.commonCustomer.province"
        >
          <el-col :span="5">
            <el-form-item
              prop="commonCustomer.province"
              :rules="customFormRules.commonCustomer.province"
            >
              <el-select
                v-model="customForm.commonCustomer.province"
                @change="selsectProvince"
                placeholder="请选择省份"
              >
                <el-option
                  v-for="item in level3Linkage.provinceList"
                  :label="item.name"
                  :value="item.name"
                  :key="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item
              prop="commonCustomer.city"
              :rules="customFormRules.commonCustomer.city"
            >
              <el-select
                v-model="customForm.commonCustomer.city"
                @change="selectCity"
                placeholder="请选择城市"
              >
                <el-option
                  v-for="item in level3Linkage.cityList.city"
                  :label="item.name"
                  :value="item.name"
                  :key="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item
              prop="commonCustomer.district"
              :rules="customFormRules.commonCustomer.district"
            >
              <el-select
                v-model="customForm.commonCustomer.district"
                placeholder="请选择区县"
              >
                <el-option
                  v-for="(item, index) in level3Linkage.districtList.area"
                  :label="item"
                  :value="item"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="详细地址：" prop="streetAddress">
          <el-col :span="11">
            <el-input type="textarea" :rows="4" v-model="customForm.streetAddress">
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import * as utils from "@/scripts/utils";
import AddEditDialog from "@/components/base/addEditDialog";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
  },
  props: {
    row: Object,
    customerUid: String,
  },
  data() {
    const nineNumberRule = (rule, value, callback) => {
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数的数字"));
      } else if (value > 999999999.99) {
        callback(new Error("最多九位数"));
      } else {
        callback();
      }
    };
    const threeNumberRule = (rule, value, callback) => {
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数的数字"));
      } else if (value > 999.99) {
        callback(new Error("最多三位数"));
      } else {
        callback();
      }
    };
    const fiveNumberRule = (rule, value, callback) => {
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数的数字"));
      } else if (value > 99999.99) {
        callback(new Error("最多五位数"));
      } else {
        callback();
      }
    };
    const fourNumberRule = (rule, value, callback) => {
      if (rule.fullField === "hospitalizationVisits" && !value) {
        callback();
        return;
      }
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数的数字"));
      } else if (value > 9999.99) {
        callback(new Error("最多四位数"));
      } else {
        callback();
      }
    };
    const liabilitiesRule = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      if (!/^100$|^(\d|[1-9]\d)(\.\d{0,2})*$/.test(value) && value !== "100.00") {
        callback(new Error("请输入最多两位小数0-100的数字"));
      } else {
        callback();
      }
    };
    const sickbedNumberRule = (rule, value, callback) => {
      if (!/^\d*$/.test(value)) {
        callback(new Error("请输入正整数"));
      } else if (value > 999999) {
        callback(new Error("最多六位数"));
      } else {
        callback();
      }
    };
    const hospitalRhankingRule = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      if (!/^\d*$/.test(value)) {
        callback(new Error("请输入正整数"));
      } else if (value > 999) {
        callback(new Error("最多三位数"));
      } else {
        callback();
      }
    };
    const employeeNumberRule = (rule, value, callback) => {
      if (!/^\d*$/.test(value)) {
        callback(new Error("请输入正整数"));
      } else if (value > 99999) {
        callback(new Error("最多五位数"));
      } else {
        callback();
      }
    };
    this.scaleOption = [
      {
        label: "50人以下",
        key: "50人以下",
      },
      {
        label: "50-200人",
        key: "50-200人",
      },
      {
        label: "200-500人",
        key: "200-500人",
      },
      {
        label: "500-1000人",
        key: "500-1000人",
      },
      {
        label: "1000-5000人",
        key: "1000-5000人",
      },
      {
        label: "5000人以上",
        key: "5000人以上",
      },
    ];
    return {
      // 客户模板
      customerModule: null,
      // 待提交的表单数据
      customForm: {
        // 不同类型客户的相同数据模型
        commonCustomer: {
          categoryUid: "",
          categoryName: "",
          name: "",
          salesmanCode: "",
          salesmanName: "",
          province: "",
          city: "",
          district: "",
          capital: "",
          scale: "",
          customerLevel: "",
        },
        businessLicenseNum: "",
        organizationCode: "",
        creditCode: "",
        streetAddress: "",
        followUpState: "",
        hospitalLevel: "",
        sickbedNumber: null,
        coverPopulation: null,
        hospitalRhanking: null,
        annualIncome: null,
        employeeNumber: null,
        outpatientVisits: null,
        addDetail: [],
        allCustomerDetail: [],
        addCustomerDetail: [],
        delCustomerDetail: [],
        hospitalizationVisits: null,
        liabilities: "",
        medicalEquipment: null,
        deviceName: "",
        deviceAmount: "",
        consumables: null,
        consumablesRunningWater: "",
        customerRemarks: "",
        // 联系人
        customerContact: [],
        crmCustomerContact: [],
        addCustomerContact: [],
        delCustomerContact: [],
      },
      // 表单校验规则
      customFormRules: {
        commonCustomer: {
          categoryUid: [{ required: true, message: "请选择客户类型", trigger: "change" }],
          name: [
            { required: true, message: "请填写客户公司名称", trigger: "blur" },
            {
              min: 0,
              max: 100,
              message: "最多100个字",
              trigger: "blur",
            },
          ],
          capital: [
            {
              pattern: /^\d+(\.\d{0,2})*$/,
              message: "必须为数字",
              trigger: "blur",
            },
            {
              min: 0,
              max: 8,
              message: "最多8个数字",
              trigger: "blur",
            },
          ],
          // scale: [
          //   { pattern: /^\d*$/, message: '必须为数字', trigger: 'blur' },
          //   {
          //     min: 0,
          //     max: 8,
          //     message: '最多8个数字',
          //     trigger: 'blur',
          //   },
          // ],
          province: [{ required: true, message: "请选择省/直辖市", trigger: "change" }],
          city: [{ required: true, message: "请选择城市", trigger: "change" }],
          district: [{ required: true, message: "请选择区/县", trigger: "change" }],
          salesmanCode: [{ required: true, message: "请选择业务员", trigger: "change" }],
        },
        businessLicenseNum: [
          { pattern: /^\d*$/, message: "必须为数字", trigger: "blur" },
          {
            min: 15,
            max: 15,
            message: "请输入15位营业执照注册号",
            trigger: "blur",
          },
        ],
        organizationCode: [
          {
            min: 10,
            max: 10,
            message: "请输入10位组织机构代码",
            trigger: "blur",
          },
        ],
        creditCode: [
          {
            min: 18,
            max: 18,
            message: "请输入18位统一社会信用代码",
            trigger: "blur",
          },
        ],
        streetAddress: [{ required: true, message: "请填写详细地址", trigger: "blur" }],
        followUpState: [{ required: true, message: "请选择跟进状态", trigger: "change" }],
        hospitalLevel: [{ required: true, message: "请选择医院等级", trigger: "change" }],
        sickbedNumber: [
          { required: true, message: "请填写病床数量", trigger: "blur" },
          { validator: sickbedNumberRule, trigger: "blur" },
        ],
        coverPopulation: [
          { required: true, message: "请填写覆盖人口", trigger: "blur" },
          { validator: threeNumberRule, trigger: "blur" },
        ],
        hospitalRhanking: [
          { required: false, message: "请填写当地医院排名", trigger: "blur" },
          { validator: hospitalRhankingRule, trigger: "blur" },
        ],
        annualIncome: [
          { required: true, message: "请填写年收入", trigger: "blur" },
          { validator: nineNumberRule, trigger: "blur" },
        ],
        employeeNumber: [
          { required: true, message: "请填写职工人数", trigger: "blur" },
          { validator: employeeNumberRule, trigger: "blur" },
        ],
        outpatientVisits: [
          { required: true, message: "请填写年门诊人次", trigger: "blur" },
          { validator: fourNumberRule, trigger: "blur" },
        ],
        hospitalizationVisits: [
          { required: false, message: "请填写年住院人次", trigger: "blur" },
          { validator: fourNumberRule, trigger: "blur" },
        ],
        liabilities: [
          { required: false, message: "请填写负债率", trigger: "blur" },
          { validator: liabilitiesRule, trigger: "blur" },
        ],
        medicalEquipment: [
          { required: false, message: "请选择医疗设备有无", trigger: "change" },
        ],
        deviceName: [
          { required: true, message: "请填写设备名称", trigger: "blur" },
          { max: 200, message: "最多200字", trigger: "blur" },
        ],
        deviceAmount: [
          { required: true, message: "请填写设备总金额", trigger: "blur" },
          { validator: fiveNumberRule, trigger: "blur" },
        ],
        consumables: [{ required: false, message: "请选择耗材有无", trigger: "change" }],
        consumablesRunningWater: [
          { required: true, message: "请填写预估耗材流水", trigger: "blur" },
          { validator: fiveNumberRule, trigger: "blur" },
        ],
        customerRemarks: [{ max: 100, message: "最多100字", trigger: "blur" }],
        allCustomerDetail: [
          { required: true, message: "请选择合作科室", trigger: "change" },
        ],
      },
      // 三级联动
      level3Linkage: {
        provinceList: utils.country,
        cityList: [],
        districtList: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      customType: "common/customType",
      contactsType: "common/contactsType",
      clerkList: "common/clerkList",
      coprationDepartment: "compact/coprationDepartment",
      hospitalLevel: "customer/hospitalLevel",
      customerFollowUp: "customer/customerFollowUp",
      customDetail: "customer/customDetail",
      customLevelList: "common/customLevelList",
      userInfo: "authority/userInfo",
    }),
  },
  watch: {
    customDetail(val) {
      if (
        this.customDetail.commonCustomer.categoryUid ===
        "ed67aad9552b4f1b8520785b9cb4bfd1"
      ) {
        this.customerModule = 2;
      } else {
        this.customerModule = 1;
      }
      val.customerDetail.forEach((item) => {
        this.customForm.allCustomerDetail.push(item.dictId);
      });
      const cloneCustom = utils.cloneObject(val);
      const filteredCloneCustom =
        cloneCustom &&
        Object.keys(cloneCustom).reduce((custom, key) => {
          if (cloneCustom[key]) custom[key] = cloneCustom[key];
          return custom;
        }, {});
      this.customForm = Object.assign(
        this.customForm,
        utils.cloneObject(filteredCloneCustom)
      );
    },
    customForm() {
      // handle() {
      console.log(this.customForm, "customForm");
      if (this.customForm.medicalEquipment === 2 || !this.customForm.medicalEquipment) {
        this.customForm.deviceName = "";
        this.customForm.deviceAmount = "";
      }
      // if (this.customForm.consumables === 2 || !this.customForm.consumables) {
      //   this.customForm.consumablesRunningWater = '';
      // }
      // },
      // deep: true,
    },
  },
  created() {
    // 客户类型列表
    this.getCustomType({
      pageNumber: 1,
      pageSize: 10,
      code: "category_customer",
    });
    // 联系人类型列表
    this.getContactsType({
      code: "category_contact",
    });
    // 业务员列表
    this.getClerkList();
    // 医院等级列表
    this.getHospitalLevelType({
      code: "category_hospital_level",
    });
    // 跟进状态列表
    this.getCustomerFollowUp({
      code: "category_customer_followUp",
    });
    // 获取合作科室
    if (this.coprationDepartment.length === 0) {
      this.getCoprationDepartmentList({
        pageNumber: 1,
        pageSize: 100,
        code: "category_department",
      });
    }
    this.getCustomDetail({
      uid: this.row.uid,
    }).then(() => {
      this.handleCustomerTypeChange();
    });
    // 获取客户等级
    this.getCustomerLevel();
  },
  methods: {
    ...mapActions({
      getCustomType: "common/getCustomType",
      getContactsType: "common/getContactsType",
      getClerkList: "common/getClerkList",
      getCoprationDepartmentList: "compact/getCoprationDepartmentList",
      getHospitalLevelType: "customer/getHospitalLevelType",
      getCustomerFollowUp: "customer/getCustomerFollowUp",
      getCustomDetail: "customer/getCustomDetail",
      updateCustom: "customer/updateCustom",
      getCustomerLevel: "common/getCustomerLevel",
    }),
    handleCustomerTypeChange(val) {
      if (!val) return;
      if (val === "ed67aad9552b4f1b8520785b9cb4bfd1") {
        this.customerModule = 2;
      } else {
        // this.rules = this.rules1;
        this.customerModule = 1;
      }
      // 2021年05月14日17:29:09 需求变更 除了政府和医生两个客户类型，其他的类型的客户，均把统一社会信用代码改成必填项
      this.creditCodeValidate();
    },
    creditCodeValidate() {
      // 2021年05月14日17:29:09 需求变更 除了政府和医生两个客户类型，其他的类型的客户，均把统一社会信用代码改成必填项
      if (
        ![
          "b8b2e093efd548a18259807bcb7fda2f",
          "3daef4ba2a424d9ba076f2189ec2acb8",
          "26229ed2c2814e05a83ae8c71edcddb0",
        ].includes(this.customForm.commonCustomer.categoryUid)
      ) {
        this.$refs.customForm.clearValidate("creditCode");
        this.customFormRules.creditCode.push({
          required: true,
          message: "请输入18位统一社会信用代码",
          trigger: "blur",
        });
      } else {
        this.$refs.customForm.clearValidate("creditCode");
        this.customFormRules.creditCode = [
          {
            min: 18,
            max: 18,
            message: "请输入18位统一社会信用代码",
            trigger: "blur",
          },
        ];
      }
    },
    // 表单提交
    customFormSubmit(formName, params) {
      // 根据categoryUid字段手动补充categoryName字段
      // 根据salesmanCode字段手动补充salesmanName字段
      params.commonCustomer.categoryName = this.getCategoryName(
        params.commonCustomer.categoryUid
      );
      params.commonCustomer.salesmanName = this.getSalesmanName(
        params.commonCustomer.salesmanCode
      );

      // 通过校验，发送submit事件与表单数据
      this.$refs[formName].validate().then((valid) => {
        if (valid) {
          params.allCustomerDetail.forEach((item) => {
            if (!this.customDetail.customerDetail.find((i) => i.dictId === item)) {
              const addItem = this.coprationDepartment.find((i) => i.uid === item);
              console.log(addItem, "addItem");
              params.addCustomerDetail.push({
                customerId: this.customDetail.commonCustomer.resourceId,
                dictId: addItem.uid,
                dictName: addItem.name,
                operatorId: this.userInfo.userUid,
              });
            }
          });
          this.customDetail.customerDetail.forEach((item) => {
            if (!params.allCustomerDetail.find((i) => i === item.dictId)) {
              params.delCustomerDetail.push({
                id: item.id,
                dictId: item.dictId,
                customerId: this.customDetail.commonCustomer.resourceId,
                dictName: item.name,
                operatorId: this.userInfo.userUid,
              });
            }
          });
          const { allCustomerDetail, ...otherParams } = params;
          // this.$emit('submit', { ...otherParams });
          this.updateCustom({ ...otherParams }).then(() => {
            this.$message({
              message: "客户信息修改成功",
              type: "success",
            });
            this.$emit("saveEditCustom");
          });
        }
      });
    },
    // 返回上一页
    handleGoBack() {
      this.$emit("closeEditCustom");
    },
    // 获取客户类型名称
    getCategoryName(categoryUid) {
      const category = this.customType.find((item) => item.uid === categoryUid);
      return category ? category.name : "";
    },
    // 获取业务员名称
    getSalesmanName(salesmanCode) {
      const salesman = this.clerkList.find((item) => item.code === salesmanCode);
      return salesman ? salesman.userName : "";
    },
    /**
     * 联动省/直辖市下拉菜单
     */
    selsectProvince() {
      this.customForm.commonCustomer.city = "";
      this.customForm.commonCustomer.district = "";
      const cityList = this.level3Linkage.provinceList.find(
        (item) => item.name === this.customForm.commonCustomer.province
      );
      this.level3Linkage.cityList = cityList || [];
      this.level3Linkage.districtList = [];
      return true;
    },
    /**
     * 联动城市下拉菜单
     */
    selectCity() {
      this.customForm.commonCustomer.district = "";
      const district = this.level3Linkage.cityList.city.find(
        (item) => item.name === this.customForm.commonCustomer.city
      );
      this.level3Linkage.districtList = district || [];
      return true;
    },
    /**
     * 新增客户联系人
     */
    addCustomerContact() {
      this.customForm.customerContact.push({
        name: "",
        mobile: "",
        duty: "",
        contactType: "",
        contactEmail: "",
        contactDepa: "",
      });
    },
    deleteCustomerContact(index) {
      this.customForm.customerContact.splice(index, 1);
    },
    changeMedicalEquipment() {
      if (!this.customForm.medicalEquipment || this.customForm.medicalEquipment === 2) {
        this.customForm.deviceAmount = "";
        this.customForm.deviceName = "";
      }
    },
    changeConsumables() {
      if (!this.customForm.consumables || this.customForm.consumables === 2) {
        this.customForm.consumablesRunningWater = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";

.custom-wrap {
  width: @maxWidth;
  margin: 0 auto;
  margin-top: 30px;
  background: #fff;
}
</style>
